import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./index.scss";
import img2020 from "../../../assets/images/2020.png";
import img2024 from "../../../assets/images/2024.png";
import Header from "../../appLayout/header";
import { useTranslation } from "react-i18next";

export default function TimelineSection() {
  const { t } = useTranslation();

  return (
    <section className="timeline-section text-light">
      <Header stylebg={"bg-color"} />
      <div className="background-text">
        MSIT
        <br /> CONSEIL
      </div>

      <Row className="justify-content-center align-items-center text-center">
        <Col lg={4} md={6} xs={6} className="d-flex justify-content-center">
          <Card className="year-card">
            <Card.Img variant="top" src={img2020} />
            <Card.Body>
              <Card.Title>2020</Card.Title>
              <Card.Text>{t("timeline.2020Text")}</Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} md={6} xs={6} className="d-flex justify-content-center">
          <Card className="year-card1">
            <Card.Img variant="top" src={img2024} />
            <Card.Body>
              <Card.Title>2024</Card.Title>
              <Card.Text>{t("timeline.2024Text")}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="d-flex justify-content-between align-items-center section-apropos">
        <div className="vision-section">
          <h6>{t("timeline.visionTitle")}</h6>
          <p>{t("timeline.visionText")}</p>
        </div>
        <div className="footer-text">{t("timeline.footer")}</div>
      </div>
    </section>
  );
}
